import { Field, Formik } from "formik";
import React, { useState, useEffect } from "react";
import { Button, Form } from "react-bootstrap";
import {
  FieldDropSide,
  FormLeaveGuard,
  SearchableList,
} from "../../components";
import { useRequest } from "../../abstracts";
import {
  getBasicPlanDetails,
  getCompaniesList,
  getEmployerSourceListForNonPayPeriod,
  getNonPayPeriodReportData,
  getPlanList,
  getReportStatusForNonPayPeriod,
  getRetirement,
  getSource,
  listEligibleRule,
  listEntryDate,
  listSource,
} from "../../services";
import {
  clearFieldValues,
  formFields,
  manageReportsFormNames,
  usDateFormat,
} from "../../utils";
import { DatePicker } from "../../components";
import {
  AllocationCalculationPeriod,
  MonthlyOptions,
  QuartelyOptions,
  SemiAnnual,
  getDateRange,
  isLeapYear,
} from "../../utils/constants/NonPayPeriod";
import NonPayPeriodReportSliderForm from "./NonPayPeriodReportSliderForm";
import moment from "moment";
import { isEqual } from "lodash";
import * as Yup from "yup";

const NonPayPeriodReportSlideOut = ({
  isSliderOpen,
  setSliderOpen,
  setFilterValues,
  setGridData,
  payload,
  setToastData,
  SetPlanListDetails,
}) => {
  const fields = formFields[manageReportsFormNames.NON_PAY_PERIOD_REPORT];
  const [planList, setPlanList] = useState([]);
  const [sourceList, setSourceList] = useState([]);
  const [allSources, setAllSources] = useState([]);
  const [sourcesApiData, setSourcesApiData] = useState([]);
  const [List, setList] = useState([]);
  const [retirementAge, setRetirementAge] = useState([]);
  const [planYear, setPlanYear] = useState([]);
  const [sourceOfMatch, setSourceOfMatch] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [planDate, setPlanDate] = useState("");
  const [eligibilityDetails, setEligibilityDetails] = useState([]);
  const [entryDateRule, setEntryDateRule] = useState("");
  const onYesClick = () => {
    setModalVisible(false);
    setSliderOpen(false);
  };

  let planEffectiveYear = new Date(planYear?.effectiveDate)?.getFullYear();
  const getPlanYearOptions = [];
  const currentYear = new Date().getFullYear();
  const yearsToShow = Math.min(currentYear - planEffectiveYear + 1, 5);

  for (let i = 0; i < yearsToShow; i++) {
    getPlanYearOptions.push({
      label: currentYear - i,
      value: i + 1,
    });
  }

  const initialValues = {
    planYear: 0,
    allocationCalculationPeriod: "",
    companyId: "",
    planId: 0,
    allocationSource: "",
    startDate: null,
    endDate: null,
    quarterId: 0,
    monthId: 0,
    rkPlanNumber: "",
    allocationSourceId: 0,
    allocationPeriodId: 1,
    sourceCategory: 0,
    semiAnnualPeriodId: 0,
  };

  useEffect(() => {
    if (List?.length !== 0 && allSources?.employerMatchSource?.sourceOfMatch) {
      const sourceIds = allSources?.employerMatchSource?.sourceOfMatch.map(
        (source) => source.sourceId
      );
      const employerSources = List.filter((empSource) =>
        sourceIds.includes(empSource?.id)
      );
      const sourceOfMatchList = employerSources.map((empSource) => ({
        sourceId: empSource.id,
        sourceName: empSource.sourceName,
      }));
      const sourceNames = sourceOfMatchList.map((_) => _.sourceName).join(", ");
      setSourcesApiData(sourceNames);
      setSourceOfMatch(sourceOfMatchList);
    }
  }, [allSources, List]);

  const { response: data } = useRequest({
    method: getCompaniesList,
    payload: 1,
    defaultResponse: [],
  });

  const generateOption = [
    ...planList.map((plan, index) => ({
      ...plan,
      label: plan.name,
      label1: plan.rkPlanNumber,
      value: plan.id,
    })),
  ];

  const validationSchema = Yup.object().shape({
    startDate: Yup.date().when("allocationCalculationPeriod", {
      is: (value) => value === "Annual" || value === "Custom",
      then: (schema) =>
        schema
          .max(
            Yup.ref(fields.endDate),
            "Start date cannot be later than End date"
          )
          .test("startDate", "Start Date restricted to Plan Year", function () {
            return (
              new Date(this.parent.startDate).getFullYear() ===
              this.parent.planYear
            );
          }),
    }),

    endDate: Yup.date().when("allocationCalculationPeriod", {
      is: (value) => value === "Annual" || value === "Custom",
      then: (schema) =>
        schema
          .test(
            "endDate",
            "Allocation Report is not available for off-calendar year plan",
            function () {
              return planDate.getDate() == 1 && planDate.getMonth() == 0;
            }
          )
          .max(
            new Date(),
            "Allocation Calculation Period End Date cannot be later than current date"
          )
          .test("endDate", "End Date restricted to Plan Year", function () {
            return (
              new Date(this.parent.endDate).getFullYear() ===
              this.parent.planYear
            );
          }),
    }),
  });

  const GenerateReportHandle = (values) => {
    const dSource = allSources?.employerDiscretionarySource;
    const mSource = allSources?.employerMatchSource;
    const sourceCategory = allSources?.sourceCategory;
    const eligibility = eligibilityDetails[0] ?? {};
    getReportStatusForNonPayPeriod({
      companyId: values.companyId,
      companyName: values.companyName,
      //temporary
      ageRequirement: false,
      serviceRequirement: false,
      exclusionApplication: false,
      entryDateApplicable: false,
      planId: values.planId,
      rkPlanNumber: values.rkPlanNumber,
      allocationSourceId: values.allocationSourceId,
      allocationSourceName: values.allocationSource,
      allocationCalculationPeriod: values.allocationPeriodId,
      planYear: values.planYear,
      startDate: values?.startDate,
      endDate: values?.endDate,
      semiAnnualPeriod: values?.semiAnnualPeriodId,
      quarter: values?.quarterId,
      month: values?.monthId,
      eligiblePayDeterminationBasedOn:
        sourceCategory == 5 || sourceCategory == 8
          ? dSource?.eligiblePaymentType
          : mSource?.eligiblePaymentType,
      employerContributionType:
        sourceCategory == 5 || sourceCategory == 8
          ? dSource?.employerContributionType
          : mSource?.employerContributionType,
      percentageOfCompensation:
        sourceCategory === 5 || sourceCategory === 8
          ? dSource?.percentageOfCompensation ?? 0
          : mSource?.employerContributionType === 2 &&
            mSource?.percentageOfCalculation
          ? mSource.percentageOfCalculation
          : 0,
      includePlanCompensation:
        sourceCategory == 5 || sourceCategory == 8
          ? dSource?.isIncludePlanCompensation
          : mSource?.isIncludePlanCompensation,
      sourceOfMatch:
        sourceCategory == 6 || sourceCategory == 7 ? sourceOfMatch : [],
      catchUpApplicable:
        (sourceCategory == 6 || sourceCategory == 7) &&
        mSource?.isCatchApplicable,
      matchPercentage:
        mSource?.employerContributionType == 2 &&
        mSource?.percentageOfCompensation != null
          ? mSource?.percentageOfCompensation
          : 0,
      compensationPercentage:
        (mSource?.employerContributionType == 2 &&
          mSource?.percentageOfCalculation) != null
          ? mSource?.percentageOfCalculation
          : 0,
      tier1MatchPercentage:
        mSource?.employerContributionType == 3 &&
        mSource?.firstTierMatchPercent != null
          ? mSource?.firstTierMatchPercent
          : 0,
      tier2MatchPercentage:
        mSource?.employerContributionType == 3 &&
        mSource?.secondTierMatchPercent != null
          ? mSource?.secondTierMatchPercent
          : 0,
      tier3MatchPercentage:
        mSource?.employerContributionType == 3 &&
        mSource?.thirdTierMatchPercent != null
          ? mSource?.thirdTierMatchPercent
          : 0,
      tier1CompensationPercentage:
        mSource?.employerContributionType == 3 &&
        mSource.firstTierCompensationMatchPercent != null
          ? mSource?.thirdTierCompensationMatchPercent
          : 0,
      tier2CompensationPercentage:
        mSource?.employerContributionType == 3 &&
        mSource?.secondTierCompensationMatchPercent != null
          ? mSource?.secondTierCompensationMatchPercent
          : 0,
      tier3CompensationPercentage:
        mSource?.employerContributionType == 3 &&
        mSource?.thirdTierCompensationMatchPercent != null
          ? mSource?.thirdTierCompensationMatchPercent
          : 0,
      includeDeferrals:
        (sourceCategory == 6 || sourceCategory == 7) &&
        mSource?.isIncludeDefferals,
      lastDayRule:
        sourceCategory == 5 || sourceCategory == 8
          ? dSource?.isLastDayRule
          : mSource?.isLastDayRule,
      hoursRequirement:
        sourceCategory == 5 || sourceCategory == 8
          ? dSource?.isHoursRequirement
          : mSource?.isHoursRequirement,
      hours:
        sourceCategory == 5 || sourceCategory == 8
          ? dSource?.hours
          : mSource?.hours,
      normalRetirement:
        sourceCategory == 5 || sourceCategory == 8
          ? dSource?.isNormalRetirement
          : mSource?.isNormalRetirement,
      normalRetirementAgeYears: retirementAge?.normalAgeYears,
      normalRetirementAgeMonths: retirementAge?.normalAgeMonths,
      earlyRetirement:
        sourceCategory == 5 || sourceCategory == 8
          ? dSource?.isEarlyRetirement
          : mSource?.isEarlyRetirement,
      earlyRetirementAgeYears: retirementAge?.earlyAgeYears,
      earlyRetirementAgeMonths: retirementAge?.earlyAgeMonths,
      disability:
        sourceCategory == 5 || sourceCategory == 8
          ? dSource?.isDisability
          : mSource?.isDisability,
      death:
        sourceCategory == 5 || sourceCategory == 8
          ? dSource?.isDeath
          : mSource?.isDeath,
      AgeRequirement:
        eligibility.eligibilityType == 1 || eligibility.eligibilityType == 3,
      ServiceRequirement:
        eligibility.eligibilityType == 2 || eligibility.eligibilityType == 3,
      age: eligibility.age ?? 0,
      ageMonth: eligibility.ageMonth ?? 0,
      exclusionApplication: eligibility?.exclusionFromRule?.exclusionType != 0,
      entryDateApplicable: entryDateRule != 0,
      entryDateRule: entryDateRule ?? 0,
      hoursOfService:
        eligibility?.yearsOfServiceDefinition == 1 ? eligibility.hours : 0,
      elapsedTimeService:
        eligibility?.yearsOfServiceDefinition == 2
          ? eligibility.lengthOfService
          : 0,
      elapsedTimePeriod:
        eligibility?.yearsOfServiceDefinition == 2 ? eligibility.period : 0,
      equivalencyHours:
        eligibility?.yearsOfServiceDefinition == 3 ? eligibility?.hours : 0,
      yearsOfServiceDefinition: eligibility?.yearsOfServiceDefinition,
      serviceRequirementOption:
        eligibility?.yearsOfServiceDefinition == 2
          ? eligibility?.lengthOfService
          : null,
    }).then((response) => {
      if (response.isSuccessfull) {
        setToastData(true);
        setFilterValues({ ...values });
        SetPlanListDetails(planYear, planList, sourceList);
        getNonPayPeriodReportData(payload).then((res) => {
          setGridData(res.nonPayPeriodReportData);
        });
        setSliderOpen(!isSliderOpen);
      }
    });
  };
  return (
    <>
      <div>
        <Formik
          validationSchema={validationSchema}
          initialValues={{
            ...initialValues,
          }}
          enableReinitialize
          validateOnChange={false}
          validateOnBlur={false}
          onSubmit={GenerateReportHandle}
        >
          {({
            handleChange,
            setFieldValue,
            setValues,
            handleSubmit,
            values,
            errors,
            touched,
            ...rest
          }) => {
            const isGenerateReportEnabled =
              values[fields.companyName] &&
              values[fields.planName] &&
              values[fields.allocationCalculationPeriod] &&
              values[fields.allocationSource] &&
              values[fields.planYear] &&
              ((values[fields.allocationCalculationPeriod] === "Custom" &&
                values[fields.endDate] &&
                values[fields.startDate]) ||
                (values[fields.allocationCalculationPeriod] === "Annual" &&
                  values[fields.endDate] &&
                  values[fields.startDate]) ||
                (values[fields.allocationCalculationPeriod] === "Semiannual" &&
                  values[fields.semiAnnualPeriod]) ||
                (values[fields.allocationCalculationPeriod] === "Quarterly" &&
                  values[fields.quarter]) ||
                (values[fields.allocationCalculationPeriod] === "Monthly" &&
                  values[fields.month]));

            const handleCompanyChange = (cId, value) => {
              setValues({
                ...clearFieldValues({
                  values: values,
                  fieldsToClear: [
                    fields.planName,
                    fields.allocationSource,
                    fields.startDate,
                    fields.endDate,
                    fields.planYear,
                    fields.allocationCalculationPeriod,
                  ],
                }),
              });
              setFieldValue(fields.companyName, value);
              setFieldValue(fields.companyId, cId);
              setSourceList([]);
              setPlanYear([]);
              getPlanList(cId).then((response) => {
                if (response.length == 1 && response[0]?.status != 0) {
                  setFieldValue(fields.planName, response[0].name);
                  setFieldValue(fields.planId, response[0].id);
                  getEmployerSourceListForNonPayPeriod(response[0].id).then(
                    (response) => {
                      setSourceList(
                        response.map((val) => ({
                          label: val.name,
                          value: val.id,
                        }))
                      );
                    }
                  );
                  getBasicPlanDetails(response[0].id).then((response) => {
                    setPlanYear(response.plan);
                    const { basicPlanDetails } = response.plan;
                    if (basicPlanDetails) {
                      const { startDate } = basicPlanDetails;
                      const startDateFormatted = `${startDate?.month}/${startDate?.day}/${currentYear}`;
                      setPlanDate(new Date(startDateFormatted));
                      setFieldValue(
                        fields?.startDate,
                        moment(startDateFormatted).format("MM/DD/YYYY")
                      );
                      setFieldValue(
                        fields?.endDate,
                        moment(startDateFormatted)
                          .add(1, "years")
                          .subtract(1, "days")
                          .format("MM/DD/YYYY")
                      );
                      setFieldValue(
                        fields.rkPlanNumber,
                        response.plan.rkPlanNumber
                      );
                    }
                  });
                  listEligibleRule(response[0].id).then((response) => {
                    const filteredRules = response.eligibilityRules.filter(
                      (rule) => {
                        const { eligibilityRuleFor, planAmendments } = rule;
                        const {
                          effectiveStartDate,
                          effectiveEndDate,
                        } = planAmendments;
                        if (eligibilityRuleFor === 1) {
                          const endDate = effectiveEndDate
                            ? new Date(effectiveEndDate)
                            : null;
                          return (
                            new Date(effectiveStartDate) <= new Date() &&
                            (!endDate || endDate >= new Date())
                          );
                        }
                        return false;
                      }
                    );
                    setEligibilityDetails(filteredRules);
                  });
                  listEntryDate(response[0].id).then((response) => {
                    setEntryDateRule(response?.entryDateRules[0].entryDateRule);
                  });
                  listSource(response[0].id).then((response) => {
                    setList(response?.employerSourcesList);
                  });
                  getRetirement(response[0].id).then((res) => {
                    setRetirementAge(res.retirement);
                  });
                  setFieldValue(fields.allocationCalculationPeriod, "Annual");
                  setFieldValue(fields.planYear, currentYear);
                }
                setPlanList(response.filter((_) => _?.status != 0) ?? []);
              });
            };

            const onPlanChange = (selectedValue, value) => {
              setValues({
                ...clearFieldValues({
                  values: values,
                  fieldsToClear: [
                    fields.allocationSource,
                    fields.startDate,
                    fields.endDate,
                  ],
                }),
              });
              listEligibleRule(value).then((response) => {
                const filteredRules = response.eligibilityRules.filter(
                  (rule) => {
                    const { eligibilityRuleFor, planAmendments } = rule;
                    const {
                      effectiveStartDate,
                      effectiveEndDate,
                    } = planAmendments;
                    if (eligibilityRuleFor === 1) {
                      const endDate = effectiveEndDate
                        ? new Date(effectiveEndDate)
                        : null;
                      return (
                        new Date(effectiveStartDate) <= new Date() &&
                        (!endDate || endDate >= new Date())
                      );
                    }
                    return false;
                  }
                );
                setEligibilityDetails(filteredRules);
              });
              listEntryDate(value).then((response) => {
                setEntryDateRule(response?.entryDateRules[0].entryDateRule);
              });
              setFieldValue(fields.allocationCalculationPeriod, "Annual");
              setFieldValue(fields.planYear, currentYear);
              getBasicPlanDetails(value).then((response) => {
                setPlanYear(response.plan);
                const { basicPlanDetails } = response.plan;
                if (basicPlanDetails) {
                  const { startDate } = basicPlanDetails;
                  const startDateFormatted = `${startDate?.month}/${startDate?.day}/${currentYear}`;
                  setPlanDate(new Date(startDateFormatted));
                  setFieldValue(
                    fields?.startDate,
                    moment(startDateFormatted).format("MM/DD/YYYY")
                  );
                  setFieldValue(
                    fields?.endDate,
                    moment(startDateFormatted)
                      .add(1, "years")
                      .subtract(1, "days")
                      .format("MM/DD/YYYY")
                  );
                  setFieldValue(
                    fields.rkPlanNumber,
                    response.plan.rkPlanNumber
                  );
                }
              });
              listSource(value).then((response) => {
                setList(response?.employerSourcesList);
              });
              getEmployerSourceListForNonPayPeriod(value).then((response) => {
                setSourceList(
                  response.map((val) => ({
                    label: val.name,
                    value: val.id,
                  }))
                );
              });

              getRetirement(value).then((res) => {
                setRetirementAge(res.retirement);
              });
              setFieldValue(fields.planName, selectedValue);
              setFieldValue(fields.planId, value);
            };

            const handlePlanYearSelect = (selectedlabel, value) => {
              setFieldValue(fields.planYear, selectedlabel);
              const { startDate, allocationCalculationPeriod } = values;
              if (allocationCalculationPeriod == "Annual") {
                const updatedStartDate = moment(startDate)
                  .year(selectedlabel)
                  .format("MM/DD/YYYY");
                const updatedEndDate = moment(updatedStartDate)
                  .add(1, "years")
                  .subtract(1, "days")
                  .format("MM/DD/YYYY");
                setFieldValue(fields.startDate, updatedStartDate);
                setFieldValue(fields.endDate, updatedEndDate);
              }
            };

            const handleAllocationSelect = (selectedlabel, value) => {
              setFieldValue(fields.allocationCalculationPeriod, selectedlabel);
              setFieldValue(fields.allocationPeriodId, value);
              if (selectedlabel === "Custom") {
                setFieldValue(fields.startDate, "");
                setFieldValue(fields.endDate, "");
              } else {
                const { basicPlanDetails } = planYear || {};
                const { startDate } = basicPlanDetails || {};
                const updatedYear = values[fields.planYear];
                const startDateFormatted = `${startDate?.month}/${startDate?.day}/${updatedYear}`;
                setFieldValue(
                  fields.startDate,
                  moment(startDateFormatted).format("MM/DD/YYYY")
                );
                setFieldValue(
                  fields.endDate,
                  moment(startDateFormatted)
                    .add(1, "years")
                    .subtract(1, "days")
                    .format("MM/DD/YYYY")
                );
              }
            };

            const handleSourceSelect = (selectedlabel, value) => {
              setFieldValue(fields.allocationSource, selectedlabel);
              setFieldValue(fields.allocationSourceId, value);
              getSource(value).then((response) => {
                setAllSources(response.source);
              });
            };

            const onDaySelected = (fieldName, value) => {
              setFieldValue(fieldName, usDateFormat(value));
            };

            return (
              <Form className="h-100" onSubmit={handleSubmit}>
                <div>
                  <div className="d-flex justify-content-between">
                    <div>
                      <h4>Non Pay Period Report</h4>
                      <h6>Advance Filter</h6>
                    </div>
                    <div className="buttons-nonPayPeriod">
                      <Button
                        variant="link"
                        className="ml-3 reset-nPayPeriod"
                        onClick={(e) => {
                          setValues(initialValues);
                          setPlanList([]);
                          setSourceList([]);
                          setPlanYear([]);
                          rest.setErrors({});
                        }}
                      >
                        Clear All
                      </Button>
                      <Button
                        variant="secondary"
                        className="search-nPayPeriod"
                        onClick={() => {
                          !isEqual(initialValues, values)
                            ? setModalVisible(true)
                            : setSliderOpen(!isSliderOpen);
                        }}
                      >
                        Cancel
                      </Button>
                      <Button
                        variant="primary"
                        className="ml-3"
                        disabled={!isGenerateReportEnabled}
                        type="submit"
                      >
                        Generate Report
                      </Button>
                    </div>
                  </div>
                  <div className="horizontal-nPayPeriod" />
                </div>

                <div className="nonPayPeriodScroll">
                  <h6 className="mt-3">Custom Filters</h6>
                  <div className="header-nPayPeriod mt-3">Company Name</div>
                  <Field
                    size="md"
                    isRequired
                    placeholder="Select"
                    name={fields.companyName}
                    value={values[fields.companyName]}
                    direction="right"
                    popupContent={
                      <SearchableList
                        label="Select Company"
                        options={
                          data &&
                          data.map((company) => ({
                            label: company.name,
                            value: company?.id,
                          }))
                        }
                        onSelect={handleCompanyChange}
                        selectedValue={values[fields.companyName]}
                        name={fields.companyName}
                      />
                    }
                    component={FieldDropSide}
                  />

                  {values.companyName && (
                    <>
                      <div className="header-nPayPeriod">Plan name & ID</div>
                      <Field
                        noLabelTransform
                        size="md"
                        isRequired
                        name={fields.planName}
                        value={values[fields.planName]}
                        placeholder="Select"
                        direction="right"
                        popupContent={
                          <SearchableList
                            label="Search Plan name or ID"
                            page="managePayroll"
                            options={planList && generateOption}
                            onSelect={(val, label) => onPlanChange(label, val)}
                            selectedValue={values[fields.planName]}
                          />
                        }
                        component={FieldDropSide}
                      />
                    </>
                  )}

                  {values.planId ? (
                    <>
                      <div className="header-nPayPeriod">Allocation source</div>
                      <Field
                        noLabelTransform
                        size="md"
                        isRequired
                        name={fields.allocationSource}
                        value={values[fields.allocationSource]}
                        placeholder="Select"
                        direction="right"
                        popupContent={
                          <SearchableList
                            label="Search source"
                            options={sourceList}
                            onSelect={(val, label) =>
                              handleSourceSelect(label, val)
                            }
                            selectedValue={values[fields.allocationSource]}
                          />
                        }
                        component={FieldDropSide}
                      />

                      <div className="header-nPayPeriod">
                        Allocation calculation period
                      </div>
                      <Field
                        noLabelTransform
                        size="md"
                        isRequired
                        name={fields.allocationCalculationPeriod}
                        value={values[fields.allocationCalculationPeriod]}
                        placeholder="Select"
                        direction="right"
                        popupContent={
                          <SearchableList
                            label="Select allocation period"
                            options={AllocationCalculationPeriod}
                            onSelect={(val, label) =>
                              handleAllocationSelect(label, val)
                            }
                            selectedValue={
                              values[fields.allocationCalculationPeriod]
                            }
                          />
                        }
                        component={FieldDropSide}
                      />

                      <div className="header-nPayPeriod">Plan year</div>
                      <Field
                        noLabelTransform
                        size="md"
                        isRequired
                        name={fields.planYear}
                        value={values[fields.planYear]}
                        placeholder="Select"
                        direction="right"
                        popupContent={
                          <SearchableList
                            label="Select plan year"
                            options={getPlanYearOptions}
                            onSelect={(val, label) => {
                              handlePlanYearSelect(label, val);
                            }}
                            selectedValue={values[fields.planYear]}
                          />
                        }
                        component={FieldDropSide}
                      />
                    </>
                  ) : null}

                  {(values.allocationCalculationPeriod == "Annual" ||
                    values.allocationCalculationPeriod == "Custom") && (
                    <>
                      <div className="header-nPayPeriod">Start Date</div>
                      <Field
                        name={fields.startDate}
                        size="smd"
                        placeholder="Select"
                        disabled={
                          values.allocationCalculationPeriod === "Annual"
                        }
                        value={values[fields.startDate]}
                        isDatePicker
                        onClear={() => setFieldValue(fields.startDate, null)}
                        popupContent={
                          <DatePicker
                            onDayClick={(value) =>
                              onDaySelected(fields.startDate, value)
                            }
                            value={values[fields.startDate]}
                          />
                        }
                        component={FieldDropSide}
                      />

                      <div className="header-nPayPeriod">End Date</div>
                      <Field
                        name={fields.endDate}
                        size="smd"
                        value={values[fields.endDate]}
                        isDatePicker
                        onClear={() => {
                          setFieldValue(fields.endDate, null);
                        }}
                        popupContent={
                          <DatePicker
                            onDayClick={(value) =>
                              onDaySelected(fields.endDate, value)
                            }
                            value={values[fields.endDate]}
                          />
                        }
                        component={FieldDropSide}
                      />
                    </>
                  )}
                  {values.allocationCalculationPeriod == "Semiannual" && (
                    <>
                      <div className="header-nPayPeriod">
                        Semi Annual Period
                      </div>
                      <Field
                        size="md"
                        isRequired
                        name={fields.semiAnnualPeriod}
                        nonPayPeriod={true}
                        value={values[fields.semiAnnualPeriod]}
                        placeholder="Select"
                        direction="right"
                        popupContent={
                          <SearchableList
                            label="Select Semi Annual Period"
                            options={SemiAnnual}
                            onSelect={(selectedValue, selectedLabel) => {
                              setFieldValue(
                                fields.semiAnnualPeriod,
                                selectedLabel
                              );
                              setFieldValue(
                                fields.semiAnnualPeriodId,
                                selectedValue
                              );
                              let startDate, endDate;
                              if (selectedValue === 1) {
                                ({ startDate, endDate } = getDateRange(
                                  values[fields.planYear],
                                  0,
                                  1,
                                  5,
                                  30
                                ));
                              } else {
                                ({ startDate, endDate } = getDateRange(
                                  values[fields.planYear],
                                  6,
                                  1,
                                  11,
                                  31
                                ));
                              }
                              setFieldValue(fields.startDate, startDate);
                              setFieldValue(fields.endDate, endDate);
                            }}
                            selectedValue={values[fields.semiAnnualPeriod]}
                          />
                        }
                        component={FieldDropSide}
                      />
                    </>
                  )}

                  {values.allocationCalculationPeriod == "Quarterly" && (
                    <>
                      <div className="header-nPayPeriod">Quarter</div>
                      <Field
                        size="md"
                        isRequired
                        name={fields.quarter}
                        nonPayPeriod={true}
                        value={values[fields.quarter]}
                        placeholder="Select"
                        direction="right"
                        popupContent={
                          <SearchableList
                            label="Select a quarter"
                            options={QuartelyOptions}
                            onSelect={(selectedValue, selectedLabel) => {
                              setFieldValue(fields.quarter, selectedLabel);
                              setFieldValue(fields.quarterId, selectedValue);
                              let startDate, endDate;
                              if (selectedValue === 1) {
                                ({ startDate, endDate } = getDateRange(
                                  values[fields.planYear],
                                  0,
                                  1,
                                  2,
                                  31
                                ));
                              } else if (selectedValue === 2) {
                                ({ startDate, endDate } = getDateRange(
                                  values[fields.planYear],
                                  3,
                                  1,
                                  5,
                                  30
                                ));
                              } else if (selectedValue === 3) {
                                ({ startDate, endDate } = getDateRange(
                                  values[fields.planYear],
                                  6,
                                  1,
                                  8,
                                  30
                                ));
                              } else {
                                ({ startDate, endDate } = getDateRange(
                                  values[fields.planYear],
                                  9,
                                  1,
                                  11,
                                  31
                                ));
                              }
                              setFieldValue(fields.startDate, startDate);
                              setFieldValue(fields.endDate, endDate);
                            }}
                            selectedValue={values[fields.quarter]}
                          />
                        }
                        component={FieldDropSide}
                      />
                    </>
                  )}

                  {values.allocationCalculationPeriod == "Monthly" && (
                    <>
                      <div className="header-nPayPeriod">Month</div>
                      <Field
                        size="md"
                        isRequired
                        name={fields.month}
                        nonPayPeriod={true}
                        value={values[fields.month]}
                        placeholder="Select"
                        direction="right"
                        popupContent={
                          <SearchableList
                            label="Select a month"
                            options={MonthlyOptions}
                            onSelect={(selectedValue, selectedLabel) => {
                              setFieldValue(fields.month, selectedLabel);
                              setFieldValue(fields.monthId, selectedValue);
                              let startDate, endDate;
                              if (selectedValue >= 1 && selectedValue <= 12) {
                                const daysArray = [
                                  31,
                                  !isLeapYear(values[fields.planYear])
                                    ? 28
                                    : 29,
                                  31,
                                  30,
                                  31,
                                  30,
                                  31,
                                  31,
                                  30,
                                  31,
                                  30,
                                  31,
                                ];
                                const month = selectedValue - 1;
                                ({ startDate, endDate } = getDateRange(
                                  values[fields.planYear],
                                  month,
                                  1,
                                  month,
                                  daysArray[month]
                                ));
                              }
                              setFieldValue(fields.startDate, startDate);
                              setFieldValue(fields.endDate, endDate);
                            }}
                            selectedValue={values[fields.month]}
                          />
                        }
                        component={FieldDropSide}
                      />
                    </>
                  )}
                  <div>
                    <NonPayPeriodReportSliderForm
                      allSources={allSources}
                      retirementAge={retirementAge}
                      sourcesApiData={sourcesApiData}
                      isGenerateReportEnabled={isGenerateReportEnabled}
                    />
                  </div>
                </div>
              </Form>
            );
          }}
        </Formik>
        <FormLeaveGuard
          showModal={modalVisible}
          handleConfirmClick={onYesClick}
          handleCancelClick={() => setModalVisible(false)}
        />
      </div>
    </>
  );
};

export default NonPayPeriodReportSlideOut;
